import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode } from "vue";
import _imports_0 from '../assets/arrow-right.png';
const _hoisted_1 = { key: 0 };
const _hoisted_2 = {
    key: 0,
    class: "docsPanel"
};
const _hoisted_3 = ["href"];
import { ref, onMounted } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useInvestments } from '@/composables/useInvestments';
import { useDocuments } from '@/composables/useDocuments';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import DrawerPanel from './elements/DrawerPanel.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import WellPanel from './elements/WellPanel.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'InvestmentPage',
    setup(__props) {
        const route = useRoute();
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getInvestmentAccount, getInvestmentInfo, deleteInvestmentAccount } = useInvestments();
        const { getDocumentsByHubId } = useDocuments();
        const wellData = ref([]);
        function onLoad() {
            const policyId = route.params.id;
            getCustomer();
            getInvestmentAccount(policyId, () => {
                wellData.value = [
                    { order: 1, label: 'Type', value: state.investmentAccount.accountType.subType },
                    { order: 2, label: 'Value', value: state.formatter.format(state.investmentAccount.balance) },
                    { order: 3, label: 'Account number', value: state.investmentAccount.accountNumber },
                    { order: 5, label: 'Account details added', value: state.dateFormatPretty.format(new Date(state.investmentAccount.createDateTime)) },
                ];
                if (state.investmentAccount.accountType.name === 'Pension') {
                    wellData.value.push({ order: 4, label: 'Retirement age', value: state.investmentAccount.retirementAge });
                }
                if (state.investmentAccount.accountType.name === 'Investment') {
                    if (state.investmentAccount.accountType.subType === 'Stocks and shares ISA') {
                        wellData.value.push({ order: 4, label: 'Tax year contribution', value: state.formatter.format(state.investmentAccount.taxYearAllowanceUsed) });
                    }
                    else {
                        wellData.value.push({ order: 4, label: 'Ownership', value: state.investmentAccount.jointStatus === 0 ? 'Sole' : 'Joint' });
                    }
                }
                getDocumentsByHubId(state.investmentAccount.id);
            });
        }
        function deleteAccount() {
            deleteInvestmentAccount(route.params.id, () => {
                getInvestmentInfo(null, true);
                router.push('/money');
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                (_unref(state).investmentAccount)
                    ? (_openBlock(), _createBlock(HeaderBlock, {
                        key: 0,
                        title: _unref(state).investmentAccount.accountType.name,
                        del: true,
                        onDelete: deleteAccount,
                        edit: 'Edit/' + _unref(route).params.id
                    }, null, 8, ["title", "edit"]))
                    : _createCommentVNode("", true),
                _createVNode(CustomerLoadWait, {
                    customer: _unref(state).investmentAccount
                }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).investmentAccount)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createVNode(WellPanel, {
                                    title: _unref(state).investmentAccount.provider ? _unref(state).investmentAccount.provider.name : 'Unknown',
                                    subTitle: "Provider",
                                    avatarLetter: _unref(state).investmentAccount.provider ? _unref(state).investmentAccount.provider.name.charAt(0) : '?',
                                    data: wellData.value
                                }, null, 8, ["title", "avatarLetter", "data"])
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                (_unref(state).documents && _unref(state).documents.length > 0)
                    ? (_openBlock(), _createBlock(DrawerPanel, {
                        key: 1,
                        bottom: "-18px",
                        openHeight: "450px",
                        title: "Saved documents",
                        backgroundColor: "white",
                        openBackgroundColor: "white"
                    }, {
                        default: _withCtx(() => [
                            (_unref(state).documents)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(state).documents, (d) => {
                                        return (_openBlock(), _createElementBlock("a", {
                                            key: d.id,
                                            href: d.url
                                        }, [
                                            _createVNode(_component_v_row, null, {
                                                default: _withCtx(() => [
                                                    _createVNode(_component_v_col, { cols: "1" }, {
                                                        default: _withCtx(() => [
                                                            _createVNode(_component_v_icon, {
                                                                class: "docIcon",
                                                                icon: "mdi-file-document-outline"
                                                            })
                                                        ]),
                                                        _: 1
                                                    }),
                                                    _createVNode(_component_v_col, { class: "docCol" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(d.name), 1),
                                                            _cache[0] || (_cache[0] = _createElementVNode("br", null, null, -1)),
                                                            _cache[1] || (_cache[1] = _createElementVNode("span", null, null, -1))
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createVNode(_component_v_col, {
                                                        cols: "1",
                                                        class: "arrowCol"
                                                    }, {
                                                        default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                            _createElementVNode("img", {
                                                                class: "arrow",
                                                                src: _imports_0
                                                            }, null, -1)
                                                        ])),
                                                        _: 1
                                                    })
                                                ]),
                                                _: 2
                                            }, 1024)
                                        ], 8, _hoisted_3));
                                    }), 128))
                                ]))
                                : _createCommentVNode("", true)
                        ]),
                        _: 1
                    }))
                    : _createCommentVNode("", true)
            ], 64));
        };
    }
});
